export const Sponsored = () => {
  return (
    <div className="sponsored">
      <img src="./images/sponsored.png" alt="sponsored" />
      <div className="sponsored-line"></div>
      <p className="sponsored-text">Sponsorluğunda</p>
    </div>
  );
};
